export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мәміле аяқталғаннан кейін ол жабылады. Ішкі қаражат пайдаланушыға аударылады."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мәмілені аяқтағыңыз келетініне сенімдісіз бе?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Иә, аяқтау"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жоқ, белсенді қалдыру"])}
}